import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {FmlxButton, FmlxIcon, FmlxLink, FmlxModal} from 'fmlx-common-ui';
import FormattedHTMLMessage from 'components/FormattedHTMLMessage';
import './CSVImportFileUploadModal.scss';
import {FAST_CSV_IMPORT_WEB_HELP_URL} from 'constants/appConstant';

function CSVImportFileUploadModal(props) {
  const {onCloseModal, onOpenFileInput, isLoadingUploadCsv} = props;
  const intl = useIntl();

  const downloadCSVImportTemplateFile = () => {
    const fileName = 'FAST CSV Template.csv';
    const urlCsvFile = '/files/fast-csv-template-v2.csv';
    const link = document.createElement('a');
    link.href = urlCsvFile;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  };

  const handleGetTemplateClick = () => {
    downloadCSVImportTemplateFile();
  };

  return (
    <FmlxModal
      open
      size="xl"
      title={intl.formatMessage({id: 'modal.csvImportFileUpload.title'})}
      onCloseClick={onCloseModal}
      customFooter={
        <div className="csv-import-file-upload-modal-footer">
          <FmlxButton
            id="modal.csvImportFileUpload.upload"
            label={
              isLoadingUploadCsv
                ? intl.formatMessage({id: 'modal.csvImportFileUpload.uploading'})
                : intl.formatMessage({id: 'modal.csvImportFileUpload.upload'})
            }
            type="primary"
            variant="contain"
            withIcon="start"
            showProgress={isLoadingUploadCsv}
            icon={<FmlxIcon name="Upload" />}
            onClick={onOpenFileInput}
          />
          <FmlxButton
            id="modal.csvImportFileUpload.downloadTemplate"
            label={intl.formatMessage({id: 'modal.csvImportFileUpload.downloadTemplate'})}
            type="secondary"
            variant="outline"
            withIcon="start"
            icon={<FmlxIcon name="Download" />}
            onClick={handleGetTemplateClick}
          />
        </div>
      }
    >
      <div className="csv-import-file-upload-modal-content">
        <div className="csv-import-file-upload-modal-content__template-text">
          <span>{intl.formatMessage({id: 'modal.csvImportFileUpload.templatePreviewText'})}</span>
          <span>
            <FmlxLink
              id="modal.csvImportFileUpload.templatePreviewLink"
              label={intl.formatMessage({id: 'modal.csvImportFileUpload.templatePreviewLink'})}
              href={FAST_CSV_IMPORT_WEB_HELP_URL}
              target="_blank"
              rel="noopener noreferrer"
            />
          </span>
        </div>
        <div className="csv-import-file-upload-modal-content__template-image-container">
          <img
            src="./svg/protocol-editor/csv-import-template-image.png"
            alt="picklist-template"
            style={{width: '100%'}}
          />
        </div>
        <FormattedHTMLMessage id="modal.csvImportFileUpload.infoText" />
      </div>
    </FmlxModal>
  );
}

CSVImportFileUploadModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  onOpenFileInput: PropTypes.func.isRequired,
  isLoadingUploadCsv: PropTypes.bool,
};

CSVImportFileUploadModal.defaultProps = {
  isLoadingUploadCsv: false,
};

export default React.memo(CSVImportFileUploadModal);
